export default {
  FETCH_INITIAL_DATA: 'FETCH_INITIAL_DATA',
  FETCH_INITIAL_DATA_SUCCESS: 'FETCH_INITIAL_DATA_SUCCESS',
  FETCH_INITIAL_DATA_ERROR: 'FETCH_INITIAL_DATA_ERROR',
};
